import { render, staticRenderFns } from "./ScanDocuments.vue?vue&type=template&id=e6cff9c4&scoped=true&"
import script from "./ScanDocuments.js?vue&type=script&lang=js&"
export * from "./ScanDocuments.js?vue&type=script&lang=js&"
import style0 from "./ScanDocuments.css?vue&type=style&index=0&id=e6cff9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cff9c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
